module.exports = __webpack_public_path__ + "static/media/icon_nav_on_quickstart.002f96df.svg";